<template>
  <v-container fluid>
    <div class="ma-5">
    <h3>Thank you for choose Sylvan Learning.  </h3>
    <p>
      Your order has been processed, please look out for an email with instructions on getting started.
    </p>
    </div>
  </v-container>
</template>

<script>
// import { mapGetters, mapActions } from "vuex";


export default {
  name: "Home",
  data: () => ({
    
  }),
  
};
</script>
